export const ContactPhone = (): string => {
	return window.config.REACT_APP_CONTACT_NUMBER;
};

export const ContactPhoneHref = (): string => {
	return window.config.REACT_APP_CONTACT_NUMBER_HREF;
};
